import { render, staticRenderFns } from "./SampleInputAndOutput.vue?vue&type=template&id=4e8aead6&scoped=true&"
import script from "./SampleInputAndOutput.vue?vue&type=script&lang=js&"
export * from "./SampleInputAndOutput.vue?vue&type=script&lang=js&"
import style0 from "./SampleInputAndOutput.vue?vue&type=style&index=0&id=4e8aead6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8aead6",
  null
  
)

export default component.exports